import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Roas = _resolveComponent("Roas");
  const _component_loading_element = _resolveComponent("loading-element");
  const _component_b_td = _resolveComponent("b-td");
  return _openBlock(), _createBlock(_component_b_td, {
    class: _normalizeClass(["portfolio-td-graph", {
      'border-top': !$props.portfolio.collapsed && !$props.portfolio.seller_id,
      'border-bottom': !$props.portfolio.collapsed && $props.portfolio.seller_id && $props.isLastSellerInWorkspace
    }])
  }, {
    default: _withCtx(() => [_createVNode(_component_loading_element, {
      loading: $props.loading
    }, {
      default: _withCtx(() => [_createVNode(_component_Roas, {
        roasData: $props.portfolio?.[$props.period_data?.[$props.selected_period]],
        periodLength: $props.periodLength,
        selected_period: $props.selected_period,
        workspace_id: $props.portfolio.workspace_id,
        seller_id: $props.portfolio.seller_id
      }, null, 8, ["roasData", "periodLength", "selected_period", "workspace_id", "seller_id"])]),
      _: 1
    }, 8, ["loading"])]),
    _: 1
  }, 8, ["class"]);
}